var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9583 32.6288C60.9599 33.1081 60.8541 33.5817 60.6487 34.0148C60.4433 34.4478 60.1434 34.8293 59.7712 35.1313L40.5212 50.6276C39.9471 51.0995 39.227 51.3574 38.4839 51.3574C37.7408 51.3574 37.0207 51.0995 36.4466 50.6276L17.1966 34.5859C16.5414 34.0413 16.1294 33.2588 16.0512 32.4104C15.973 31.562 16.235 30.7173 16.7795 30.0621C17.3241 29.4069 18.1067 28.9949 18.955 28.9167C19.8034 28.8385 20.6481 29.1005 21.3033 29.6451L38.5 43.9863L55.6966 30.1263C56.1676 29.734 56.741 29.4848 57.3491 29.4082C57.9573 29.3315 58.5746 29.4307 59.1282 29.694C59.6817 29.9573 60.1482 30.3736 60.4726 30.8937C60.7969 31.4138 60.9654 32.0159 60.9583 32.6288Z",
    fill: "#164453"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.5a41395c9364416c2d46bdab1584d1fe.svg";
export { ForwardRef as ReactComponent };